import { REWIND_SLIDES } from '../../rewindModal.types';

import styles from './animatedBackground.module.scss';

interface AnimatedBackgroundProps {
  currentSlideIndex: number;
}

/**
 * AnimatedBackground - A continuous gradient background that spans all slides.
 * The background position shifts as slides change, creating a seamless
 * transition. Includes subtle ambient animations to make it feel alive.
 */
export function AnimatedBackground({
  currentSlideIndex,
}: AnimatedBackgroundProps): JSX.Element {
  const totalSlides = REWIND_SLIDES.length;
  // Calculate the position offset based on current slide (0-100%)
  const positionOffset = (currentSlideIndex / (totalSlides - 1)) * 100;

  return (
    <div className={styles.backgroundContainer}>
      {/* Main gradient layer that shifts with slides */}
      <div
        className={styles.gradientLayer}
        style={{
          backgroundPosition: `${positionOffset}% 50%`,
        }}
      />

      {/* Floating orbs for ambient effect */}
      <div className={styles.orbsContainer}>
        <div className={`${styles.orb} ${styles.orb1}`} />
        <div className={`${styles.orb} ${styles.orb2}`} />
        <div className={`${styles.orb} ${styles.orb3}`} />
        <div className={`${styles.orb} ${styles.orb4}`} />
      </div>
    </div>
  );
}
